import { Action } from '@ngrx/store';

export const CLEAR_ERROR = '[Error] Clear';

/**
 * An user have seen error - clear storage so that he wont get redirect to error page again.
 */
export class ClearErrorAction implements Action {
    readonly type = CLEAR_ERROR;
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions = ClearErrorAction;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/actions/clear-error.action.ts